import React from 'react'
import { LookupServieURL } from "../../../config/config";
import { useEffect, useState } from "react";
import { getApiCall, postApiCall } from "../../../services/apiHelper";
import {
  TextField,
  CircularProgress,
  Autocomplete,
  Checkbox,
} from "@mui/material";

import Button from "@mui/material/Button";
import { useParams, useNavigate } from 'react-router-dom';
import { ServiceName } from '../../../constants';
import { CurrentUser } from "../../../redux/slices/currentUserSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { wait } from '@testing-library/user-event/dist/utils';
import { ToastMessage } from "../../util/ToastMessage";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export const Firm = () => {
  const RegionOptions = [
    { label: 'US', value: 'US' },
    { label: 'EMEA', value: 'EMEA' },
    { label: 'APAC', value: 'APAC' }
  ];

  const [regionList, setRegionList] = useState<any[]>(RegionOptions);
  const [selectedRegion, setSelectedRegion] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const params = useParams();
  console.log(params);
  const page = params.page;
  const navigate = useNavigate();
  const userId = params.userRoleId;
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [isError, setIsError] = useState<{ isError: boolean; message: string }>(
    { isError: false, message: "" }
  );

  const [appraisalFirmData, setAppraisalFirmData] = useState<any>();
  const [name, setName] = React.useState('');
  const [appraisalfirm, setAppraisalFirm] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [emailErrored, setEmailErrored] = React.useState(false);
  const [regionErrored, setRegionErrored] = React.useState(false);
  const currentUserData: CurrentUser = useAppSelector(
    (state) => state.currentUser.data
  );

  const Validate = () => {
    if (!name || !appraisalfirm) {
      return true
    }
    else {
      return false;
    }

  }
  const ValidateEmail = () => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email) {
      let isValidEmail = pattern.test(email);
      if (isValidEmail) {
        setEmailErrored(false);
        return false;
      }
      else {
        setEmailErrored(true);
        return true;
      }
    }
    else {
      setEmailErrored(true);
      return true;
    }
  }

  let isEditForm = false;
  let isViewForm = false;
  if (page == "view") {
    isViewForm = true;
  }
  else if (page == "edit") {
    isEditForm = true;
  }

  const appraiserId = params.id;

  useEffect(() => {
    setLoading(true);
    getApiCall(LookupServieURL + "/externalappraisers/getbyid/" + appraiserId, "LookupService").then((data) => {
      setAppraisalFirmData(data);
      setLoading(false);
    });
  }, [appraiserId]);

  useEffect(() => {
    setName(appraisalFirmData?.result?.name);
    setAppraisalFirm(appraisalFirmData?.result?.appraisalFirm);
    setEmail(appraisalFirmData?.result?.email);
    var region: any[] = appraisalFirmData?.result?.region?.split(";");
    if (appraisalFirmData?.result?.region) {
      var regionlst: any[] = RegionOptions.filter((data) =>
        region.includes(data.label)
      );
      setSelectedRegion(regionlst)
    }
  }, [appraisalFirmData]);

  const update = () => {
    let region = selectedRegion.map((region) => region.label).join(";");
    let error = true;
    let isEmailValid = ValidateEmail();
    error = Validate();
    if (!error) {
      error = isEmailValid;
      if (!error) {
        if (region == "") {
          error = true;
          setRegionErrored(true);
        }
      }
    }
    if (!error) {
      try {
        setTimeout(() => {
          setLoading(true);
        }, 1000);
        const AppraiserFirm = {
          id: appraisalFirmData.result.id,
          name: name,
          appraisalFirm: appraisalfirm,
          email: email,
          status: appraisalFirmData.result.status,
          createdBy: appraisalFirmData.result.createdBy,
          created: appraisalFirmData.result.created,
          lastModifiedBy: currentUserData.email,
          lastModified: appraisalFirmData.result.lastModified,
          region: region
        }
        var url = LookupServieURL + "/externalappraisers/Update";
        postApiCall(url, AppraiserFirm, ServiceName.LOOKUPSERVICE)
          .then((res: any) => {
            setIsSuccess(true);
            wait(3000).then(() => {
              navigate("/appraiserfirm/list");
            })
          })
          .catch((error: any) => {
            console.log(error);
            setIsError({
              isError: true,
              message: "There were error while saving the form",
            });
            wait(3000).then(() => {
              setTimeout(() => {
                setLoading(false);
              }, 1000);
            });
          });
      }
      catch (error) {
        console.log(error);
      } finally {
        wait(1000).then(() => {
          setTimeout(() => {
            setLoading(false);
          }, 1000);
        });
      }
    }
  };

  const OpenEditForm = () => {
    navigate("/appraiserfirm/edit/" + appraiserId);
  };

  const RedirectToDashboard = () => {
    navigate("/appraiserfirm/list");
  };

  const handelRegionChange = (regions: any) => {
    setSelectedRegion(
      regions.sort((a: any, b: any) => a.value.localeCompare(b.value)).reverse()
    );
    if (selectedRegion.length > 0) {
      setRegionErrored(false);
    }
    else {
      setRegionErrored(true);
    }
  }

  return (
    <div>
      {loading &&
        <div className="overlaySpinner">
          <CircularProgress />
        </div>
      }

      {!loading &&
        <div>

          {isEditForm &&
            <div className="form-wrap">
              {isSuccess && (
                <ToastMessage message="User Role map is submitted" severity="success" />
              )}
              {isError.isError && (
                <ToastMessage message={isError.message} severity="error" />
              )}
              <Box sx={{ width: "100%", typography: "body1" }}>
                <Grid container spacing={3}>
                  <Grid item xs={6} sm={6}>
                    <TextField
                      id="outlined-Appraiser-Firm"
                      variant="outlined"
                      label="Appraiser Firm Id*"
                      className="Autopopulatefield"
                      defaultValue={appraisalFirmData.result.id}
                      InputProps={{
                        readOnly: true,
                      }}
                      size="small"
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={6} sm={6}>
                    <TextField
                      required
                      InputLabelProps={{
                        sx: {
                          '& .MuiInputLabel-asterisk': {
                            color: 'red',
                          },
                        },
                      }}
                      id="outlined-External-Appraiser"
                      label="External Appraiser Name"
                      defaultValue={appraisalFirmData?.result?.name}
                      onChange={(e) => setName(e.target.value)}
                      size="small"
                      fullWidth
                      helperText={!name ? "Name is required" : ""}
                      error={!name}
                    /></Grid>
                  <Grid item xs={6} sm={6}>
                    <TextField
                      required
                      InputLabelProps={{
                        sx: {
                          '& .MuiInputLabel-asterisk': {
                            color: 'red',
                          },
                        },
                      }}
                      id="outlined-appraisalFirm"
                      label="Appraiser Firm"
                      defaultValue={appraisalFirmData?.result?.appraisalFirm}
                      onChange={(e) => setAppraisalFirm(e.target.value)}
                      size="small"
                      fullWidth
                      helperText={!appraisalfirm ? "Appraiser Firm is required" : ""}
                      error={!appraisalfirm} />
                  </Grid>
                  <Grid item xs={6} sm={6}>
                    <TextField
                      required
                      InputLabelProps={{
                        sx: {
                          '& .MuiInputLabel-asterisk': {
                            color: 'red',
                          },
                        },
                      }}
                      id="outlined-email"
                      label="Email Address"
                      defaultValue={appraisalFirmData?.result?.email}
                      onChange={(e) => setEmail(e.target.value)}
                      size="small"
                      fullWidth
                      helperText={emailErrored ? "Email is required & should be in correct Email format" : ""}
                      error={emailErrored}
                    /></Grid>
                  <Grid item xs={6} sm={6}>
                    <Autocomplete
                      multiple
                      aria-label="Region_test"
                      id="checkboxes-tags-demo"
                      options={regionList}
                      value={selectedRegion}
                      isOptionEqualToValue={(option, value) =>
                        option.label === value.label &&
                        option.value === value.value
                      }
                      disableCloseOnSelect
                      getOptionLabel={(option) => option.label}
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.label}
                        </li>
                      )}
                      onChange={(event, value) => {
                        handelRegionChange(value);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Region"
                          size="small"
                          error={regionErrored}
                          helperText={regionErrored ? "Please select the region" : ""}
                          placeholder="Selece region"
                          required
                          InputLabelProps={{
                            sx: {
                              '& .MuiInputLabel-asterisk': {
                                color: 'red',
                              },
                            },
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Button sx={{ textTransform: "none" }} onClick={update} variant="contained" disabled={isSuccess} size="medium" color="success">Submit</Button>
                    <Button sx={{ textTransform: "none", ml: 2 }} variant="contained" size="medium" color="error"
                      onClick={RedirectToDashboard}>Cancel</Button>
                  </Grid>
                </Grid>
              </Box>
            </div>

          }
          {isViewForm &&
            <div className="form-wrap">
              <Box sx={{ width: "100%", typography: "body1" }}>
                <Grid container spacing={3}>
                  <Grid item xs={6} sm={6}>
                    <TextField
                      id="outlined-Appraiser-Firm-Id"
                      variant="outlined"
                      className="Autopopulatefield"
                      label="Appraiser Firm Id*"
                      defaultValue={appraisalFirmData.result.id}
                      InputProps={{
                        readOnly: true,
                      }}
                      size="small"
                      fullWidth
                    /></Grid>
                  <Grid item xs={6} sm={6}>
                    <TextField
                      required
                      InputLabelProps={{
                        sx: {
                          '& .MuiInputLabel-asterisk': {
                            color: 'red',
                          },
                        },
                      }}
                      id="outlined-External-Appraiser"
                      label="External Appraiser Name"
                      className="Autopopulatefield"
                      value={appraisalFirmData?.result?.name}
                      InputProps={{
                        readOnly: true,
                      }}
                      size="small"
                      fullWidth
                    />
                  </Grid> <Grid item xs={6} sm={6}>
                    <TextField
                      required
                      InputLabelProps={{
                        sx: {
                          '& .MuiInputLabel-asterisk': {
                            color: 'red',
                          },
                        },
                      }}
                      id="outlined-appraisalFirm"
                      label="Appraiser Firm"
                      className="Autopopulatefield"
                      defaultValue={appraisalFirmData.result.appraisalFirm}
                      InputProps={{
                        readOnly: true,
                      }}
                      size="small"
                      fullWidth />
                  </Grid><Grid item xs={6} sm={6}>
                    <TextField
                      required
                      InputLabelProps={{
                        sx: {
                          '& .MuiInputLabel-asterisk': {
                            color: 'red',
                          },
                        },
                      }}
                      id="outlined-email"
                      label="Email Address"
                      className="Autopopulatefield"
                      defaultValue={appraisalFirmData.result.email}
                      InputProps={{
                        readOnly: true,
                      }}
                      size="small"
                      fullWidth
                    /></Grid><Grid item xs={6} sm={6}>
                    <Autocomplete
                      multiple
                      aria-label="Region_test"
                      id="checkboxes-tags-demo"
                      options={regionList}
                      value={selectedRegion}
                      readOnly={true}
                      isOptionEqualToValue={(option, value) =>
                        option.label === value.label &&
                        option.value === value.value
                      }
                      disableCloseOnSelect
                      getOptionLabel={(option) => option.label}
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.label}
                        </li>
                      )}
                      onChange={(event, value) => {
                        handelRegionChange(value);
                      }}
                      sx={{
                        '& .MuiInputLabel-asterisk': {
                          color: 'red',
                        },
                      }
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Region"
                          size="small"
                          placeholder="Selece region"
                          required
                          className="Autopopulatefield"
                        />
                      )}
                    />  </Grid>
                  <Grid item xs={12} sm={12}>
                    <Button sx={{ textTransform: "none" }} variant="contained" size="medium" color="success" onClick={OpenEditForm}>Edit</Button>
                    <Button variant="contained" size="medium" color="error"
                      sx={{ textTransform: "none", ml: 2 }} onClick={RedirectToDashboard}>Close</Button>
                  </Grid>
                </Grid></Box>
            </div>
          }
        </div>
      }
    </div>
  )
};
